import React from 'react';
import styled, {css} from 'styled-components';

const CarouselIndicator = ({selected, total, brand}) => {
    return (
        <IndicatorsContainer>
            {Array.from({length: total}).map((_, index) => {
                return (
                    <SlideIndicator
                        key={index}
                        selected={index === selected}
                        brand={brand}
                    />
                );
            })}
        </IndicatorsContainer>
    );
};

const IndicatorsContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
`;

const SlideIndicator = styled.div`
    background: rgb(241, 239, 241);
    border-radius: 0px;
    height: 4px;
    width: 16px;
    cursor: pointer;

    :not(:last-child) {
        margin-right: 8px;
    }

    ${props =>
        props.brand === 'dkids' &&
        css`
            border-radius: 2px;
        `};

    ${props =>
        props.selected &&
        (props.brand !== 'dkids'
            ? css`
                  background: linear-gradient(90deg, #f55a86 0%, #ec098c 100%);
              `
            : css`
                  background: #7cdb5c;
              `)};

    
}

    
`;

export default CarouselIndicator;
